import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  requestButton: {
    id: 'react-components.jm/spn',
    defaultMessage: 'Reset',
  },
  requestFailed: {
    id: 'react-components.MafjU7',
    defaultMessage: 'Request failed. Token may be invalid.',
  },
  requestSuccess: {
    id: 'react-components.1gZSU3',
    defaultMessage: 'Password successfully reset!',
  },
  passwordLabel: {
    id: 'react-components.5sg7KC',
    defaultMessage: 'Password',
  },
});
